import React from "react";
import { NameCell, Muted, Strong } from "../../components/tableCells/tableCells";
import gridSx from "../../styles/gridSx";
import { DataGrid } from "@mui/x-data-grid";

//scss import
import Styles from "./franchise.module.scss";

// bootstrap import
import { Container, Row, Col } from "react-bootstrap";

// //svg import
import { ReactComponent as Add } from "../../resources/svg/Add.svg";
import { ReactComponent as Edit } from "../../resources/svg/Group 79.svg";
import { ReactComponent as Delete } from "../../resources/svg/Trash.svg";
import { ReactComponent as Deleteb } from "../../resources/svg/buetrash.svg";

// components import
import Cbtn from "../../components/commonbutton/cbtn";
import ResponsiveDrawer from "../../components/responsiveDrawer/responsiveDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import Deletefilemodal from "../../components/deletfilemodal/deletefilemodal";
import { useDispatch, useSelector } from "react-redux";
import { selectStatus } from "../../store/features/adminSlice";
import {
  getFranchise,
  getFranchiseById,
  selectfranchiseData,
  deleteFranchise,
  selectFranchiseError,
} from "../../store/features/franchiseSlice";
import LoadingScreen from "../../components/loadingSpinner/loadingScreen";
// import AddFranchise from "../../components/addFranchise/addFranchise";
// import EditFranchise from "../../components/editFranchise/editFranchise";

const Franchise = () => {
  const [franchiseRow, setFranchiseRow] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showSeq, setShowSeq] = React.useState(false);
  const [showEditSeq, setShowEditSeq] = React.useState([]);
  const [showDel, setShowDel] = React.useState(false);
  const [deleteIds, setDeleteIds] = React.useState([]);

  let navigate = useNavigate();
  let location = useLocation();
  let loadingStatus = useSelector(selectStatus);

  React.useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);

  React.useEffect(() => {
    if (loadingStatus === "error") {
      navigate("/login");
    }
  }, [loadingStatus]);

  let dispatch = useDispatch();
  let teamDetails = useSelector(selectfranchiseData);
  let teamError = useSelector(selectFranchiseError);

  let getData = async () => {
    let res = await dispatch(getFranchise());
    setLoading(false);
    return res;
  };

  React.useEffect(() => {
    if (teamDetails[0]) {
      setFranchiseRow(() => {
        let temp = teamDetails.map((ele, i) => ({
          id: ele?._id,
          count: i + 1,
          // The team logo, so the name cell can show it instead of initials.
          name: { name: ele?.name, image: ele?.image },
          ownerName: ele?.owner?.name,
          purse: ele?.owner?.purse,
          biddingPlayersBought: ele?.boughtPlayers?.length || 0,
          editDelete: {
            details: ele,
            // show: false,
            // setShow: (value) => {
            //   setFranchiseRow((prev) => {
            //     let temp = [...prev];
            //     temp[i].editDelete.show = value;
            //     return temp;
            //   });
            // },
          },
        }));
        return temp;
      });
    }
  }, [teamDetails]);

  React.useEffect(() => {
    getData();
  }, []);

  const columns = [
    // Product Name----FIRST TITLE CELL---
    {
      field: "count",
      headerName: "SR",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 70,
      renderCell: (params) => <Muted>{params.value}</Muted>,
    },
    {
      field: "name",
      headerName: "Teams",
      description: "This column has a value getter and is not sortable.",
      sortable: true,
      flex: 3,
      // minWidth: 300,
      // Logos are transparent artwork of varying shape, so they are contained
      // on white rather than cropped to fill the tile.
      renderCell: (params) => (
        <NameCell
          name={params.value?.name}
          image={params.value?.image}
          fit="contain"
        />
      ),
      sortComparator: (v1, v2) =>
        String(v1?.name || "").localeCompare(String(v2?.name || "")),
    },
    {
      field: "ownerName",
      headerName: "Owner",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 2,
      // minWidth: 300,
      renderCell: (params) => {
        return (
          <>
            <Muted>{params.value}</Muted>
          </>
        );
      },
    },
    {
      field: "purse",
      headerName: "Purse",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 2,
      // minWidth: 300,
      renderCell: (params) => {
        return (
          <>
            <Strong>{params.value ? `${params.value / 100} CR` : "-"}</Strong>
          </>
        );
      },
    },
    {
      field: "biddingPlayersBought",
      headerName: "Players Bought",
      description: "This column has a value getter and is not sortable.",
      sortable: true,
      flex: 2,
      // minWidth: 300,
      renderCell: (params) =>
        params.value ? <Strong>{params.value}</Strong> : <Muted>0</Muted>,
    },
    // NO HEADER NAME ----- FIFTH TITLE CELL----

    {
      field: "editDelete",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 2,
      minWidth: 200,
      renderHeader: () => {
        return (
          <>
            <Cbtn
              className="huehuehue-white"
              type={"submit"}
              onClick={() => {
                if (deleteIds[0]) {
                  setShowDel(!showDel);
                } else {
                  alert("Select Franchises");
                }
              }}
            >
              <Deleteb
                style={{
                  marginRight: "8px",
                  marginBottom: "5px",
                }}
              />
              Delete
            </Cbtn>
          </>
        );
      },
      renderCell: (params) => {
        return (
          <>
            <Edit
              onClick={() => {
                navigate(`/teams/${params.value.details._id}`);
              }}
              className={Styles.editSvg}
            />
            {/* <EditFranchise
              teamDetails={params.value.details}
              show={params.value.show}
              setShow={params.value.setShow}
            /> */}
            <Delete
              onClick={() => {
                setDeleteIds([params.value.details._id]);
                setShowDel((prev) => !prev);
              }}
              className={Styles.deleteSvg}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      {loadingStatus === "Loading" && <LoadingScreen />}
      {loadingStatus === "fulfilled" && (
        <ResponsiveDrawer>
          <Container className={Styles.container}>
            <div className={Styles.toolbar}>
              <div>
                <h1 className={Styles.mainHeading}>Teams</h1>
                <div className={Styles.subHeading}>
                  {franchiseRow?.length
                    ? `${franchiseRow.length} ${
                        franchiseRow.length === 1 ? "franchise" : "franchises"
                      } in this auction`
                    : "Create the franchises that will bid for players"}
                </div>
              </div>
              <div className={Styles.actions}>
                <Cbtn
                  className="huehuehue"
                  type={"submit"}
                  to="/teams/new"
                  style={{ backgroundColor: "#0040A8" }}
                >
                  <Add className={Styles.add} />
                  New Team
                </Cbtn>
              </div>
            </div>

            {/* ------------------TABLE START----------- */}

            <Row className={`${Styles.table} ${Styles.gridWrap}`}>
              <DataGrid
                autoWidth
                autoHeight
                rowHeight={55}
                disableSelectionOnClick
                disableColumnFilter
                disableColumnMenu
                headerHeight={80}
                onSelectionModelChange={(ids) => {
                  setDeleteIds(ids);
                }}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={gridSx}
                loading={loading && !teamError}
                rows={franchiseRow}
                columns={columns}
                checkboxSelection
              />
            </Row>
          </Container>
          <Deletefilemodal
            ids={deleteIds}
            show={showDel}
            deleteFn={deleteFranchise}
            setShow={setShowDel}
          />

          {/* </Row> */}
          {/* -------------------TABLE END------------------ */}
        </ResponsiveDrawer>
      )}
    </>
  );
};

export default Franchise;
